import React from 'react';

import { Route } from 'helpers/routes/routes';
import { CommonPageData, socThemeScreensUrl } from 'helpers/routes/CommonPageData';

export enum EntityAccessManagementRoute {
  Accesses = '/entityaccessmanagement/accesses',
  CreateAccess = '/entityaccessmanagement/create-access',
  ContactPersons = '/entityaccessmanagement/contact-persons',
  ContactPersonAccess = '/entityaccessmanagement/contact-person-access/:cpRefNo',
  VerifyEntityAccess = '/entityaccessmanagement/verify-entity-access',
  PrimaryContactPersonConfirmation = '/entityaccessmanagement/contact-person-confirmation',
}

const defaultCommonPageData: CommonPageData = {
  pageTitle: 'onecrm.common.pageTitle.accessManagement',
  visibleForAnonym: false,
};

export const EntityAccessManagementRoutes: Route[] = [
  {
    path: EntityAccessManagementRoute.Accesses,
    exact: true,
    component: React.lazy(() => import('views/pages/Accesses/Accesses/Accesses')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.19.4',
      templateUrl: socThemeScreensUrl('2-19-4-pristupy.html'),
    },
  },
  {
    path: EntityAccessManagementRoute.ContactPersonAccess,
    exact: true,
    component: React.lazy(() => import('views/pages/Accesses/ModifyAccess/ContactPersonAccess/ContactPersonAccess')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.19.3',
      templateUrl: socThemeScreensUrl('2-19-3-pristupy-kontaktni-osoby.html'),
    },
  },
  {
    path: EntityAccessManagementRoute.ContactPersons,
    exact: true,
    component: React.lazy(() => import('views/pages/Accesses/ContactPersons/ContactPersons')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.3.1.2.4',
      templateUrl: socThemeScreensUrl('2-3-1-2-4-kontaktni-osoby-zakaznika.html'),
    },
  },
  {
    path: EntityAccessManagementRoute.CreateAccess,
    exact: true,
    component: React.lazy(() => import('views/pages/Accesses/CreateAccess/CreateAccess')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.19.5',
      templateUrl: socThemeScreensUrl('2-19-5-pridani-pristupu.html'),
    },
  },
  {
    path: EntityAccessManagementRoute.VerifyEntityAccess,
    exact: true,
    component: React.lazy(() => import('views/pages/VerifyEntityAccess/VerifyEntityAccess')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.6.5',
      templateUrl: socThemeScreensUrl('2-6-5-potvrzeni-vazby-ko-zakaznika.html'),
    },
  },
  {
    path: EntityAccessManagementRoute.PrimaryContactPersonConfirmation,
    exact: true,
    component: React.lazy(() => import('views/pages/Accesses/ContactPersonConfirmation/ContactPersonConfirmation')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.6.6',
      templateUrl: socThemeScreensUrl('2-6-6-prihlaseni-primarniho-spravce.html'),
    },
  },
];
